import React, { useEffect } from 'react';
import { Route, Switch, BrowserRouter as Router } from 'react-router-dom';
import { Provider } from 'react-redux';
import store from 'modules/store';
import Chat from 'components/pages/Chat';
import './App.css';
import smoothscroll from 'smoothscroll-polyfill';
import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';

function App() {
  useEffect(() => {
    const url = window.location.origin;
    if (!url.includes('https')) {
      window.location = "https://yongin.go.kr/chat";
    }
  });

  smoothscroll.polyfill();
  return (
    <Provider store={store}>
      <Router>
        <Switch>
          <Route exact path="*" component={Chat} />
        </Switch>
      </Router>
    </Provider>
  );
}

export default App;
